const StalePropertiesCard = ({ properties, errorMessage }) => {
  return (
    <section className="panel-card admin-re-quality-card">
      <p className="eyebrow">Freshness</p>
      <h3>Stale properties</h3>
      <p className="muted admin-re-quality-note">
        Stale listings may need refresh, removal, or status update.
      </p>

      {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}

      {!errorMessage && !properties?.length ? (
        <p className="muted">No stale properties in this sample.</p>
      ) : null}

      {!errorMessage && properties?.length ? (
        <ul className="admin-re-quality-list">
          {properties.map((property) => (
            <li key={property.id}>
              <strong>{property.title}</strong>
              <span>
                {property.displaySource || property.sourceCode} · last seen{" "}
                {property.lastSeenAt || "—"}
                {property.daysSinceLastSeen !== null && property.daysSinceLastSeen !== undefined
                  ? ` (${property.daysSinceLastSeen} days)`
                  : ""}
              </span>
              {property.sourceUrl ? (
                <a href={property.sourceUrl} target="_blank" rel="noreferrer">
                  View source listing
                </a>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
};

export default StalePropertiesCard;
